/**
 * 스마트 안전장비 가이드 출처 (국토부 가이드라인 + 자유게시판 안내 글)
 */
export const SMART_EQUIPMENT_GUIDELINE = {
  title: '스마트 안전장비 활용 가이드라인',
  publisher: '국토교통부 · 국토안전관리원',
  revision: '2026.05 개정',
  itemCount: 14,
};

/** create_board_smart_safety_equipment_post.py 로 등록한 자유게시판 글 */
export const SMART_EQUIPMENT_BOARD_POST_ID = 3;

export const SMART_EQUIPMENT_BOARD_POST_PATH = `/board/${SMART_EQUIPMENT_BOARD_POST_ID}`;

export const SMART_EQUIPMENT_BOARD_POST_TITLE =
  '[안전정보] 스마트 안전장비 활용 가이드라인(2026.05 개정) — 14종 단위장비 안내';
